/* ILS — custom overrides JS */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  ready(function () {
    var bar = document.querySelector('.ils-header-bar');
    if (!bar) return;

    // TASK-2069 — move the suggest panel + backdrop out of
    // `.shopify-section-ils-header-search` to <body>. Fixes two real-device
    // bugs that Playwright (Chromium) doesn't reproduce:
    //   1. Touch-tap inside the panel closed it. The section wrapper is
    //      `pointer-events: none` while `body.ils-collapsed`. TASK-2068
    //      restored `pointer-events: auto` on the panel via CSS, and that
    //      worked in Chromium — but iOS WebKit's compositor-level hit-test
    //      still routes initial touches to the pointer-events:none ancestor,
    //      so `event.target` on the resulting click ends up outside the
    //      panel and the TASK-2067 outside-click handler closes it.
    //   2. Sale badges from the bestsellers rail below painted over the
    //      panel. The section wrapper is `position:sticky; z-index:49`
    //      which creates a stacking context — TASK-1706's bump of
    //      `.ils-suggest { z-index: 201 }` was confined inside that context
    //      and the section externally still stacks at 49 in root. On iOS
    //      that's tight enough for compositor-promoted card decorations to
    //      leak through. Same class of bug TASK-1706 fixed for the hero
    //      by adding `isolation: isolate`.
    // Both problems disappear when the panel + backdrop become direct
    // children of <body> — no ancestor pointer-events chain, no sticky
    // stacking context confinement, z=201 wins in root.
    var suggestPanel = document.querySelector('.ils-suggest');
    var suggestBackdropEl = document.querySelector('.ils-suggest__backdrop');
    if (suggestPanel && suggestPanel.parentElement !== document.body) {
      document.body.appendChild(suggestPanel);
    }
    if (suggestBackdropEl && suggestBackdropEl.parentElement !== document.body) {
      document.body.appendChild(suggestBackdropEl);
    }

    var lastY = 0;
    var ticking = false;
    var COLLAPSE_ADD = 40;
    var COLLAPSE_REMOVE = 20;
    var TOGGLE_LOCKOUT_MS = 350;
    var lockedUntil = 0;
    var body = document.body;

    function onScroll() {
      var now = Date.now();
      if (now < lockedUntil) { ticking = false; return; }
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var isCollapsed = body.classList.contains('ils-collapsed');
      if (!isCollapsed && y > COLLAPSE_ADD) {
        body.classList.add('ils-collapsed');
        bar.classList.add('is-shadowed');
        lockedUntil = now + TOGGLE_LOCKOUT_MS;
        if (window.__ilsCenterFlag) window.__ilsCenterFlag();
      } else if (isCollapsed && y < COLLAPSE_REMOVE) {
        body.classList.remove('ils-collapsed');
        bar.classList.remove('is-shadowed');
        // TASK-2313 — do NOT close the suggest overlay when it was opened
        // by the #site-search anchor sequence (handleSiteSearch scrolls to
        // top which trips this "back at top → expand header" branch mid-
        // animation). Sticky flag is set by custom-anchor-autofocus.js and
        // cleared on user close (backdrop / escape / lens toggle below).
        if (!window.__ilsSuggestAnchorSticky) {
          body.classList.remove('ils-suggest-open');
        }
        lockedUntil = now + TOGGLE_LOCKOUT_MS;
        if (window.__ilsCenterFlag) window.__ilsCenterFlag();
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
    onScroll();

    var lensBtn = document.querySelector('[data-ils-lens]');
    if (lensBtn) {
      lensBtn.addEventListener('click', function (e) {
        e.preventDefault();
        // TASK-2313 — user is taking control of the overlay; release the
        // anchor stickiness so subsequent scroll-collapse can close it.
        window.__ilsSuggestAnchorSticky = false;
        var willOpen = !body.classList.contains('ils-suggest-open');
        body.classList.toggle('ils-suggest-open');
        // TASK-2240 — the .ils-suggest panel renders its own <input> that the
        // user sees once the panel opens. Without this, focus stayed on the
        // lens <button> and the user had to tap the visible input a second
        // time before the keyboard would target it. Focus() must run
        // synchronously inside this touch/click handler for iOS to accept it
        // and surface the keyboard.
        if (willOpen) {
          var suggestInput = document.querySelector('.ils-suggest .ils-search input[type="search"]');
          if (suggestInput) {
            try { suggestInput.focus({ preventScroll: true }); }
            catch (_) { suggestInput.focus(); }
          }
        }
      });
    }
    var backdrop = document.querySelector('.ils-suggest__backdrop');
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        window.__ilsSuggestAnchorSticky = false;
        body.classList.remove('ils-suggest-open');
      });
    }
    // TASK-2067 — outside-click close.
    // The backdrop alone isn't enough: on suggest-open the header-bar section
    // is bumped to z-index 80 (TASK-1672) so its input renders above the
    // backdrop (z-index 47), which means taps in the collapsed header row
    // (around the lens button) hit the header bar and never reach the
    // backdrop. Close on any click outside the panel, the lens toggle,
    // and the inline top-search section (which owns the focus-to-open flow
    // from TASK-1684 and must stay interactive while the panel is open).
    //
    // TASK-2070 — WebKit target-drift fallback.
    // Focusing the inline input (TASK-1684) synchronously adds ils-suggest-open,
    // which pops the panel over the tap point *before* the synthetic click
    // dispatches. On iOS WebKit the click then arrives with event.target =
    // <body> (not the input, not the panel that is now under the pointer) —
    // so all three inside-selectors below miss and the handler would close
    // the panel we just opened. When the target is a document-root ancestor
    // like <body>/<html>, recompute the real hit target from the click
    // coordinates via elementFromPoint and run the selector checks against
    // that. Chromium delivers a specific target here, so it's a no-op there.
    document.addEventListener('click', function (e) {
      if (!body.classList.contains('ils-suggest-open')) return;
      var t = e.target;
      if (!t || t.nodeType !== 1) return;
      if (t === document.body || t === document.documentElement) {
        var atPoint = document.elementFromPoint(e.clientX, e.clientY);
        if (atPoint) t = atPoint;
      }
      if (t.closest('.ils-suggest')) return;
      if (t.closest('[data-ils-lens]')) return;
      if (t.closest('.ils-search-section')) return;
      window.__ilsSuggestAnchorSticky = false;
      body.classList.remove('ils-suggest-open');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        window.__ilsSuggestAnchorSticky = false;
        body.classList.remove('ils-suggest-open');
        closeBurger();
      }
    });

    // TASK-1998: fallback flag images switched from Shopify Files
    // (lang-en.png / lang-ru.png) to flagcdn.com.
    // TASK-2055: switcher previously only handled /en-eu/ ↔ /ru-eu/ and
    // dumped visitors on de-de/lv-lv/et-ee/lt-lt (and their ru-* variants)
    // into the EU market via the altHref fallback. Now the locale segment
    // is parsed generically and the swap stays inside the visitor's market.
    var langBtn = document.querySelector('[data-ils-lang]');
    var langFlag = document.querySelector('[data-ils-lang-flag]');
    if (langBtn && langFlag && !langBtn.dataset.bound) {
      langBtn.dataset.bound = '1';
      var primaryFlagOverride = langBtn.dataset.primaryFlag || '';
      var altFlagOverride = langBtn.dataset.altFlag || '';
      var altHref = langBtn.dataset.altHref || '/ru-eu/';

      // Market → primary (non-Russian) language + flag shown when the
      // visitor is already on the Russian version and needs to switch back.
      var MARKET_META = {
        eu: { lang: 'en', flag: 'https://flagcdn.com/w80/gb.png' },
        de: { lang: 'de', flag: 'https://flagcdn.com/w80/de.png' },
        lv: { lang: 'lv', flag: 'https://flagcdn.com/w80/lv.png' },
        ee: { lang: 'et', flag: 'https://flagcdn.com/w80/ee.png' },
        lt: { lang: 'lt', flag: 'https://flagcdn.com/w80/lt.png' }
      };
      var RU_FLAG = altFlagOverride || 'https://flagcdn.com/w80/ru.png';

      function paintFlag(url) {
        langFlag.innerHTML = '<img src="' + url + '" alt="" loading="eager">';
      }

      function parseLocale() {
        var m = (window.location.pathname || '/').match(/^\/([a-z]{2})-([a-z]{2})(\/|$)/);
        if (!m) return null;
        return { lang: m[1], market: m[2], prefix: '/' + m[1] + '-' + m[2] };
      }

      function computeSwap() {
        var p = window.location.pathname || '/';
        var q = window.location.search || '';
        var loc = parseLocale();
        if (!loc || !MARKET_META[loc.market]) {
          var fallback = altHref;
          if (q) fallback += (fallback.indexOf('?') === -1 ? q : '&' + q.substring(1));
          return { href: fallback, flag: RU_FLAG };
        }
        var meta = MARKET_META[loc.market];
        var newLang;
        var newFlag;
        if (loc.lang === 'ru') {
          newLang = meta.lang;
          newFlag = (loc.market === 'eu' && primaryFlagOverride) ? primaryFlagOverride : meta.flag;
        } else {
          newLang = 'ru';
          newFlag = RU_FLAG;
        }
        var newPrefix = '/' + newLang + '-' + loc.market;
        return { href: newPrefix + p.substring(loc.prefix.length) + q, flag: newFlag };
      }

      var swap = computeSwap();
      paintFlag(swap.flag);

      langBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = computeSwap().href;
      });
    }

    var burgerToggle = document.querySelector('[data-ils-burger-open]');
    var burger = document.querySelector('[data-ils-burger]');

    if (burger && burger.parentElement !== document.body) {
      document.body.appendChild(burger);
    }

    function openBurger() {
      if (!burger) return;
      body.classList.remove('ils-suggest-open');
      burger.classList.add('is-open');
      burger.setAttribute('aria-hidden', 'false');
      body.classList.add('ils-burger-open');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeBurger() {
      if (!burger) return;
      burger.classList.remove('is-open');
      burger.setAttribute('aria-hidden', 'true');
      body.classList.remove('ils-burger-open');
      document.documentElement.style.overflow = '';
    }
    if (burgerToggle) burgerToggle.addEventListener('click', openBurger);
    if (burger) {
      burger.querySelectorAll('[data-ils-burger-close]').forEach(function (el) {
        el.addEventListener('click', closeBurger);
      });
      burger.querySelectorAll('a.ils-burger__row, a.ils-burger__sub-row, a.ils-burger__bar, a.ils-burger__restock').forEach(function (a) {
        a.addEventListener('click', function () { closeBurger(); });
      });
    }

    var subToggles = document.querySelectorAll('[data-ils-burger-sub]');
    subToggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var wrap = btn.closest('.ils-burger__group');
        if (!wrap) return;
        wrap.classList.toggle('is-open');
      });
    });
  });

  function initProof() {
    document.querySelectorAll('[data-ils-proof]').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      var track = el.querySelector('.ils-proof__track');
      if (!track) return;
      var visible = parseInt(el.dataset.visible, 10) || 3;
      var cycle = parseInt(el.dataset.cycle, 10) || 2000;
      var originals = Array.prototype.slice.call(track.children);
      var N = originals.length;
      if (N < 2) return;
      for (var i = 0; i < visible; i++) {
        track.appendChild(originals[i].cloneNode(true));
      }
      var step = 0;
      var stepW = 100 / visible;
      function rotate() {
        step++;
        track.style.transition = 'transform .55s cubic-bezier(.4,0,.2,1)';
        track.style.transform = 'translateX(-' + (step * stepW) + '%)';
        if (step === N) {
          setTimeout(function () {
            track.style.transition = 'none';
            step = 0;
            track.style.transform = 'translateX(0)';
          }, 560);
        }
      }
      setInterval(rotate, cycle);
    });
  }

  function initPcardSlides() {
    document.querySelectorAll('[data-ils-pslides]').forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var slides = wrap.querySelectorAll('.ils-pcard__slide');
      if (slides.length < 2) return;
      var pips = wrap.parentElement.querySelectorAll('.ils-pcard__pip');
      var idx = 0;
      setInterval(function () {
        slides[idx].classList.remove('is-on');
        if (pips[idx]) pips[idx].classList.remove('is-on');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('is-on');
        if (pips[idx]) pips[idx].classList.add('is-on');
      }, 2600);
    });
  }

  function initGiveawayWave() {
    document.querySelectorAll('[data-ils-give-cta]').forEach(function (cta) {
      if (cta.dataset.bound) return;
      cta.dataset.bound = '1';
      var interval = parseInt(cta.dataset.waveInterval, 10) || 2500;
      function fire() {
        cta.classList.remove('is-waving');
        void cta.offsetWidth;
        cta.classList.add('is-waving');
      }
      var inView = false;
      var timer = null;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            inView = entry.isIntersecting;
            if (inView && !timer) {
              fire();
              timer = setInterval(fire, interval);
            } else if (!inView && timer) {
              clearInterval(timer); timer = null;
              cta.classList.remove('is-waving');
            }
          });
        }, { threshold: 0.4 });
        io.observe(cta);
      } else {
        fire();
        setInterval(fire, interval);
      }
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-ils-faq]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var items = root.querySelectorAll('details.ils-faq__item');
      items.forEach(function (det) {
        var summary = det.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', function (e) {
          if (det.open) return;
          var open = root.querySelector('details.ils-faq__item[open]');
          if (open && open !== det) {
            e.preventDefault();
            open.removeAttribute('open');
            setTimeout(function () { det.setAttribute('open', ''); }, 90);
          }
        });
      });
    });
  }

  function initEmailConfirm() {
    document.querySelectorAll('[data-ils-email-confirm]').forEach(function (sec) {
      if (sec.dataset.bound) return;
      sec.dataset.bound = '1';
      var form = sec.querySelector('.ils-email__form');
      var modal = sec.querySelector('[data-ils-email-modal]');
      if (!form || !modal) return;

      var input = form.querySelector('input[type="email"]');
      var emailOut = modal.querySelector('[data-ils-email-modal-email]');
      var btnConfirm = modal.querySelector('[data-ils-email-modal-confirm]');
      var btnEdit = modal.querySelector('[data-ils-email-modal-edit]');
      var closers = modal.querySelectorAll('[data-ils-email-modal-close]');
      var confirmed = false;

      function open(email) {
        if (emailOut) emailOut.textContent = email;
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('ils-email-modal-open');
        setTimeout(function () { if (btnConfirm) btnConfirm.focus(); }, 30);
      }

      function close() {
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('ils-email-modal-open');
      }

      form.addEventListener('submit', function (e) {
        if (confirmed) return;
        if (!input || !input.value || !input.checkValidity()) return;
        e.preventDefault();
        open(input.value.trim());
      });

      if (btnConfirm) btnConfirm.addEventListener('click', function () {
        confirmed = true;
        close();
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });

      if (btnEdit) btnEdit.addEventListener('click', function () {
        close();
        if (input) { input.focus(); input.select(); }
      });

      closers.forEach(function (c) { c.addEventListener('click', close); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    });
  }

  function initEmailPillStory() {
    var badges = document.querySelectorAll('.shopify-section-ils-email .ils-email__badge');
    if (!badges.length) return;
    badges.forEach(function (badge) {
      if (badge.dataset.ilsStoryBound) return;
      badge.dataset.ilsStoryBound = '1';
      var raw = badge.textContent;
      if (!raw) return;
      badge.textContent = '';
      var visibleIdx = 0;
      for (var i = 0; i < raw.length; i++) {
        var ch = raw.charAt(i);
        if (ch === ' ' || ch === '\t' || ch === '\n') {
          badge.appendChild(document.createTextNode(' '));
          continue;
        }
        var span = document.createElement('span');
        span.className = 'ils-pill-char';
        if (/[0-9%]/.test(ch)) span.classList.add('is-digit');
        span.style.setProperty('--i', visibleIdx);

        var seed = visibleIdx + 1;
        var ang = (seed * 137 + 23) % 360;
        var dist = 70 + ((seed * 53) % 50);
        var rot = ((seed * 211) % 720) - 360;
        var rad = ang * Math.PI / 180;
        var dx = Math.cos(rad) * dist;
        var dy = Math.sin(rad) * dist;
        span.style.setProperty('--dx', dx.toFixed(1) + 'px');
        span.style.setProperty('--dy', dy.toFixed(1) + 'px');
        span.style.setProperty('--rot', rot.toFixed(0) + 'deg');

        span.textContent = ch;
        badge.appendChild(span);
        visibleIdx++;
      }
      badge.style.setProperty('--ils-pill-count', visibleIdx);
      badge.classList.add('is-animated');
    });
  }

  if (document.readyState !== 'loading') {
    initProof(); initPcardSlides(); initGiveawayWave(); initFaq(); initEmailConfirm(); initEmailPillStory();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initProof(); initPcardSlides(); initGiveawayWave(); initFaq(); initEmailConfirm(); initEmailPillStory();
    });
  }
})();
